/**
 * @generated SignedSource<<4d215d4b1bdf428df39e60dab0d86e6f>>
 * @relayHash 761fdabff92558e2582749765555927a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d61bbfcdbfaef0f2e7e4959cdf78e7496aed16ae81a29cb948745cb2709b50e7

import type { ConcreteRequest } from 'relay-runtime';
export type useSmartFolderAncestorSyncQuery$variables = {
  contentId: string;
};
export type useSmartFolderAncestorSyncQuery$data = {
  readonly ptpage: {
    readonly id: string;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly subType: string | null;
        readonly type: string | null;
      } | null> | null;
    } | null;
    readonly subType: string | null;
    readonly type: string | null;
  } | null;
};
export type useSmartFolderAncestorSyncQuery = {
  response: useSmartFolderAncestorSyncQuery$data;
  variables: useSmartFolderAncestorSyncQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = {
  "kind": "ScalarField",
  "name": "subType"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "CURRENT",
          "DRAFT"
        ]
      }
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 5
          }
        ],
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "nearestAncestors",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ],
        "storageKey": "nearestAncestors(first:5)"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSmartFolderAncestorSyncQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSmartFolderAncestorSyncQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "761fdabff92558e2582749765555927a",
    "id": "d61bbfcdbfaef0f2e7e4959cdf78e7496aed16ae81a29cb948745cb2709b50e7",
    "metadata": {},
    "name": "useSmartFolderAncestorSyncQuery",
    "operationKind": "query",
    "text": "query useSmartFolderAncestorSyncQuery($contentId:ID!){ptpage(id:$contentId,status:[CURRENT,DRAFT]){id,type,subType,nearestAncestors(first:5){nodes{id,type,subType}}}}"
  }
};
})();

(node as any).hash = "bcee0b680822894c9500220037e533a1";

export default node;
